import { gql } from '@apollo/client';

import {
  TEST_SESSION_SPEAKER_FRAGMENT,
  TEST_SESSION_ANSWER_FRAGMENT,
  TESTER_RATING_FRAGMENT,
} from '../../../core/graphql/test-sessions';

const QUERY_LIMIT = 10;
const ORDER = 'created_at DESC';
const OFFSET = 0;
const POOL_INTERVAL = 3000;

const GET_PROJECT_PARTICIPANTS = gql`
  query ProjectParticipants(
    $projectId: ID!,
    $segmentId: ID,
    $tsIsApproved: Boolean,
    $removed: Boolean
    $bookingStatus: [TestSessionBookingStatusEnum!],
  ) {
    projectParticipants(
      projectId: $projectId,
      segmentId: $segmentId,
      tsIsApproved: $tsIsApproved,
      removed: $removed,
      bookingStatus: $bookingStatus,
    ) {
      id
    }
  }
`;

const GET_TESTER_BY_ID = gql`
  query Tester($id: ID!) {
    tester(id: $id) {
      id
      approved
      testSessions {
        id
        videoKey
        videoUrl
        status
        approved
        removed
        ...TesterRating
        transcriptText {
          text
          speakerTag
          startTime
        }
        testSessionAnswers {
          ...TestSessionAnswerFields
        }
        testSessionSpeakers {
          ...TestSessionSpeakerFields
        }
        deviceType
        osType
        osVersion
        deviceInfo {
          retailBrand
          marketingName
        }
        practiceTestStatus
      }
      user {
        id
        guest
        profile {
          id
          firstName
          lastName
          linkedinFields {
            emailAddress
            educationLevel
            linkedinUrl
            currentPosition {
              title
              description
              seniority
              company {
                name
                size
                industry
              }
              startDate {
                year
                month
              }
              endDate {
                year
                month
              }
            }
          }
          email
          birthdate
          gender
          raceEthnicHeritage
          annualHouseholdIncome
          otherDevices
          country
          state
          jobCategories {
            name
          }
        }
      }
      screenerSession {
        id
        screenerSessionAnswers {
          id
          questionId
          questionOptionId
        }
      }
    }
  }
  ${TESTER_RATING_FRAGMENT}
  ${TEST_SESSION_ANSWER_FRAGMENT}
  ${TEST_SESSION_SPEAKER_FRAGMENT}
`;

const SAVE_RATING_TESTER = gql`
  mutation UpdateTesterRating($id: ID!, $attributes: TesterRatingAttributes!) {
    updateTesterRating(testSessionId: $id, attributes: $attributes) {
      testSession {
        id
        ...TesterRating
      }
    }
  }
  ${TESTER_RATING_FRAGMENT}
`;

const GET_RECORDING_BY_TEST_SESSION_ID = gql`
  query Recordings($testSessionId: ID!) {
    recordings(testSessionId: $testSessionId) {
      id
      testSessionId
      type
      fileKey
      convertedVideoKey
      videoUrl
      status
      error
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export {
  GET_TESTER_BY_ID,
  GET_RECORDING_BY_TEST_SESSION_ID,
  GET_PROJECT_PARTICIPANTS,
  OFFSET,
  ORDER,
  POOL_INTERVAL,
  QUERY_LIMIT,
  SAVE_RATING_TESTER,
};
